<template>
    <sidebar-group class="properties-component" :class="component.type + '-properties-component'" :title="title"
                   :expanded.sync="component.expanded" :active="component.active" :sub-group="subGroup">
        <template v-if="isLocal()" #title>
            {{title|tr}} <span class="f-400 f-10 ml-2">#{{component.id}}</span>
        </template>
        <template #actions>
            <b-checkbox v-if="!component.required" class="toggle-active float-right ml-3" size="lg" v-model="component.active" :title="tr(`Enable/Disable Component|Activer/Désactiver le composant`)"/>

            <b-btn v-if="advancedProperties && component.active" variant="outline" class="toggle-binding float-right mr-1" size="sm"
                   @click="showAdvancedProperties()" :title="'Show advanced options|Options avancées'|tr">
                <i class="fas fa-brush fa-fw"/>
            </b-btn>
            <b-btn v-if="component.allowBinding && !noBinding && bindingEnabled && component.active" :variant="component.useBinding ? 'primary' : 'outline'" class="toggle-binding float-right mr-1" size="sm"
                   @click="component.useBinding = !component.useBinding" :title="'Bind to variable|Lier à une variable'|tr">
                <i class="fas fa-database fa-fw"/>
            </b-btn>
            <b-btn v-if="component.allowMediaQuery && component.active" :variant="component.mediaQuery.expanded ? 'primary' : 'outline'" class="toggle-binding float-right mr-1" size="sm"
                   @click="component.mediaQuery.toggle()" :title="'Toggle Responsive Options|Afficher/masquer les options responsives'|tr">
                <i class="fas fa-fw fa-laptop-mobile"/>
            </b-btn>
            <b-btn v-if="advancedProperties && component.plugins?.liquid?.active === true" variant="primary" class="toggle-binding float-right mr-1" size="sm"
                   @click="showAdvancedProperties(`code`)" :title="'Custom Liquid Code|Code Liquid personnalisé'|tr">
                <i class="fas fa-code fa-fw"/>
            </b-btn>
<!--            <b-btn v-if="advancedProperties && component.customCss" variant="primary" class="toggle-binding float-right mr-1" size="sm"-->
<!--                   @click="showAdvancedProperties(`style`)" :title="'Custom CSS|CSS personnalisé'|tr">-->
<!--                <i class="fas fa-file-css fa-fw"/>-->
<!--            </b-btn>-->
<!--            <b-btn v-if="component.allowAdvanced && !noAdvanced && component.active" :variant="component.advanced ? 'primary' : 'outline'" class="toggle-binding float-right mr-1" size="sm"-->
<!--                   @click="component.advanced = !component.advanced" :title="'Toggle Advanced Options|Afficher/masquer les options avancées'|tr">-->
<!--                <i class="fas fa-plus fa-fw"/>-->
<!--            </b-btn>-->
        </template>

        <slot></slot>

        <sidebar-group v-if="component.active && component.mediaQuery.expanded" :title="'Device Display|Affichage par appareil'|tr" sub-group>
            <b-form-group>
                <btn-checkbox v-model="component.mediaQuery.desktop.visible" :title="'Select if visible on desktop device|Visibilité sur ordinateur'|tr">
                    <i class="fas fa-desktop" style="font-size: 16pt;"/>
                </btn-checkbox>
                <btn-checkbox v-model="component.mediaQuery.tablet.visible" :title="'Select if visible on tablet device|Visibilité sur tablette'|tr">
                    <i class="fas fa-tablet-screen" style="font-size: 16pt;"/>
                </btn-checkbox>
                <btn-checkbox v-model="component.mediaQuery.mobile.visible" :title="'Select if visible on mobile device|Visibilité sur mobile'|tr">
                    <i class="fas fa-mobile-iphone" style="font-size: 16pt;"/>
                </btn-checkbox>
                <btn-checkbox v-model="component.mediaQuery.kiosk.visible" :title="'Select if visible on kiosk device|Visibilité sur kiosque'|tr">
                    <i class="fak fa-kiosk" style="font-size: 16pt;"/>
                </btn-checkbox>
                <btn-checkbox v-model="component.mediaQuery.wheelchair.visible" :title="'Select if visible on kiosk with wheelchair mode|Visibilité sur kiosque en mode handicapé'|tr">
                    <i class="fas fa-wheelchair" style="font-size: 16pt;"/>
                </btn-checkbox>
            </b-form-group>
        </sidebar-group>

        <advanced-properties-component v-if="advancedProperties && advancedPropertiesVisible" v-model="component" :visible.sync="advancedPropertiesVisible"
                                       :tab="advancedTab" :block="block" :bound-item="boundItem">
            <!-- Always use <b-tab> in here -->
            <slot name="advanced-properties"/>
        </advanced-properties-component>
    </sidebar-group>
</template>

<script>

// properties-component #hot-reload-debug
import SidebarGroup from "@/components/editor/properties/components/sidebar-group.vue";
import BtnCheckbox from "@/components/editor/properties/inputs/btn-checkbox.vue";
import EBtnCheckbox from "../../../../../vue-components/components/e-btn-checkbox.vue";
import AdvancedPropertiesComponent from "@components/editor/properties/components/advanced-properties-modal.vue";

export default {
    name: `properties-component`,
    components: {AdvancedPropertiesComponent, BtnCheckbox, EBtnCheckbox, SidebarGroup},
    props: {
        value: {type: Object, required: true},
        title: {type: String, required: true},
        block: {type: Object},
        boundItem: {type: Object},
        noBinding: {type: Boolean},
        noAdvanced: {type: Boolean},
        subGroup: {type: Boolean},
        advancedProperties: {type: Boolean}
    },
    data() {
        return {
            advancedPropertiesVisible: false,
            advancedTab: null
        }
    },
    computed: {
        component: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit(`input`, value);
            }
        },
        previewIcon() {
            switch (this.previewMode) {
                case `mobile`:
                    return `fas fa-mobile-iphone`;
                case `tablet`:
                    return `fas fa-tablet-screen`;
                case `kiosk`:
                    return `fak fa-kiosk`;
                default:
                    return `fas fa-desktop`;
            }
        },
        bindingEnabled() {
            return this.cmsPage.itemType || (this.block.cmsEnabled && this.block.itemId);
        },
        itemTypeDef() {
            if (!this.block.pageItemTypeDef) {
                return null;
            }
            return this.block.pageItemTypeDef;
        }
    },
    methods: {
        showAdvancedProperties(tab = null) {
            this.advancedPropertiesVisible = true;
            this.advancedTab = tab;
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .toggle-active {
    display: inline-flex;
    top: -3px;
    //position: absolute;
    //left: 5px;
    //top: 4px;
}

.toggle-binding {
    position: relative;
    top: 0;
    //border-radius: 3px;
    padding: 3px 2px;
    line-height: 1;

    &.btn-outline {
        color: #555;
        background: rgba(white, 1);
    }
}
</style>
